import Events from './components/Events';

export default Events;